export const SUBSCRIPTION_BENEFITS = {
  FREE: [
    { type: 'param', key: 'ss_count_lang_support', params: { count: 20 } },
    { type: 'add', key: 'credit_per_month', params: { amount: '1,000' } },
    { type: 'time', key: 'ss_small_conversation', times: { minutes: 32 } },
    { type: 'time', key: 'label_conference', times: { minutes: 9 } },
    { type: 'time', key: 'ss_label_convention', times: { minutes: 14 } },
  ],
  STARTER: [
    { type: 'param', key: 'ss_count_lang_support', params: { count: 20 } },
    { type: 'api', key: 'credit_per_month', paramKey: 'creditIncluded' },
    { type: 'time', key: 'ss_small_conversation', times: { hours: 8 } },
    { type: 'time', key: 'label_conference', times: { hours: 2, minutes: 7 } },
    { type: 'time', key: 'ss_label_convention', times: { hours: 3, minutes: 34 } },
    { type: 'static', key: 'ss_simultaneous_session' },
  ],
  PRO: [
    { type: 'param', key: 'ss_count_lang_support', params: { count: 20 } },
    { type: 'api', key: 'credit_per_month', paramKey: 'creditIncluded' },
    { type: 'time', key: 'ss_small_conversation', times: { hours: 46 } },
    { type: 'time', key: 'label_conference', times: { hours: 12, minutes: 16 } },
    { type: 'time', key: 'ss_label_convention', times: { hours: 20, minutes: 41 } },
    { type: 'static', key: 'ss_simultaneous_session' },
    { type: 'static', key: 'ss_refill_supported' },
  ],
  ENTERPRISE: [
    { type: 'static', key: 'all_products_available' },
    { type: 'static', key: 'full_service_support' },
    { type: 'static', key: 'multi_channel_service_support' },
    { type: 'static', key: 'enterprise_consulting_support' },
    { type: 'static', key: 'interpretation_operation_support' },
  ],
};
